<template>
    <div class="t-desktop desktop">
        <slot name="overlay" />
        <slot name="header" />
        <div class="desktop__main-container" role="main">
            <slot name="sidepanel" />
            <ODMap />
        </div>
        <slot name="footer" />
        <slot name="modal" />
    </div>
</template>

<script>
import { mapState } from 'vuex';

import ALoader from '../../atoms/a-loader/a-loader';
import ODMap from '../../unique-organisms/o-d-map/o-d-map';

export default {
    name: 'TDesktop',
    components: {
        ODMap,
    }
}
</script>

<style lang="scss">
@import "t-desktop";    
</style>